<template>
    <div style="width: 100%;padding: 20px;box-sizing: border-box;">
        <el-button size="small" type="primary" @click="doShowEditAdvisorDialog(null)"
            style="width: 120px;">Add Adviser</el-button>

        <el-table :data="dataList" style="margin-top: 20px;" empty-text="No Data" :highlight-current-row="false"
            :highlight-selection-row="false" :header-cell-class-name="'custom-head-cell'"
            :row-class-name="'custom-row-bg'">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <div style="background-color: #f5f5f5;padding: 15px 10px;box-sizing: border-box;">
                        <div style="display: flex;margin-bottom: 15px;">
                            <p style="flex: 0.5;text-align: center;color:#FF8833;font-weight: bold;">No.</p>
                            <p style="flex: 1.5;text-align: center;color:#FF8833;font-weight: bold;">Assigned Clubs</p>
                            <p style="flex: 1;text-align: center;color:#FF8833;font-weight: bold;">Tenure Start</p>
                            <p style="flex: 1;text-align: center;color:#FF8833;font-weight: bold;">Tenure End</p>
                            <p style="flex: 1;text-align: center;color:#FF8833;font-weight: bold;">Advisory Class</p>
                            <p style="flex: 0.8;text-align: center;color:#FF8833;font-weight: bold;">Status</p>
                            <p style="flex: 1;text-align: center;color:#FF8833;font-weight: bold;">Operation</p>
                        </div>
                        <div style="background-color: #fff;height: 1px;width: 100%;">
                        </div>
                        <div v-for="(club, index) in scope.row.clubs" :key="index"
                            style="border-bottom: 1px solid #fff;padding: 10px 0px;box-sizing: border-box;">
                            <div style="display: flex; align-items: center;">
                                <p style="flex: 0.5;text-align: center;color:#FF8833">{{ index + 1 }}</p>
                                <p style="flex: 1.5;text-align: center;color:#FF8833">{{ club.name }}</p>
                                <p style="flex: 1;text-align: center;color:#FF8833">{{ club.tenure_start || '-' }}</p>
                                <p style="flex: 1;text-align: center;color:#FF8833">{{ club.tenure_end || '-' }}</p>
                                <p style="flex: 1;text-align: center;color:#FF8833">{{ club.advisory_class || '-' }}</p>
                                <div style="flex: 0.8;text-align: center;">
                                    <el-tag :type="club.is_current ? 'success' : 'info'" size="small">
                                        {{ club.is_current ? 'Current' : 'Past/Future' }}
                                    </el-tag>
                                </div>
                                <div style="flex: 1;text-align: center;color:#FF8833">
                                    <el-button type="danger" size="small"
                                        @click="doRemoveAdvisorFromClub(club, scope.row)">Remove</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="Adviser Name">
                <template slot-scope="scope">
                    {{ scope.row.contact_info.contact_givenName + ' ' +
                        scope.row.contact_info.contact_lastName }}
                </template>
            </el-table-column>
            <el-table-column prop="contact_info.contact_email" label="Adviser Email"></el-table-column>
            <el-table-column prop="" label="Clubs">
                <template slot-scope="scope">
                    {{ scope.row.clubs.length }}
                </template>
            </el-table-column>
            <el-table-column prop="" label="Account Status">
                <template slot-scope="scope">
                    {{ scope.row.account_status && scope.row.account_status == 'inactive' ? 'Inactive' : 'Active' }}
                </template>
            </el-table-column>
            <el-table-column prop="" label="Operation" width="284px">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="doChangeAdviserAccountStatus(scope.row)">{{
                        scope.row.account_status && scope.row.account_status == 'inactive' ? 'Activate' : 'Deactivate'
                    }}</el-button>
                    <el-button type="primary" size="small" @click="doShowEditAdvisorDialog(scope.row)">Adviser
                        Info</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :visible.sync="showAdvisorInfoDialog"
            :title="advisorInfo.id == '' ? 'Add an Adviser' : 'Adviser Account Info'" width="800px">
            <div>
                <el-form :inline="true" ref="form" :rules="rules" :model="advisorInfo" label-width="140px">
                    <el-form-item label="First Name" prop="contact_givenName">
                        <el-input v-model="advisorInfo.contact_givenName" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Last Name" prop="contact_lastName">
                        <el-input v-model="advisorInfo.contact_lastName" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Email" prop="contact_email">
                        <el-input v-model="advisorInfo.contact_email" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item label="Gender" prop="contact_prefix">
                        <el-select v-model="advisorInfo.contact_prefix" placeholder="Please select"
                            style="width: 220px;">
                            <el-option v-for="item in genderList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Subject" prop="contact_discipline">
                        <el-select v-model="advisorInfo.contact_discipline" placeholder="Please select"
                            style="width: 220px;">
                            <el-option v-for="item in subjectList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Position" prop="contact_position">
                        <el-input v-model="advisorInfo.contact_position" style="width: 220px;"></el-input>
                    </el-form-item>
                </el-form>
                <div style="width: 100%; text-align: center; margin-top: 30px">
                    <el-button size="medium" @click="showAdvisorInfoDialog = false">Cancel</el-button>
                    <el-button type="primary" size="medium" @click="saveAdvisorInfo()">Confirm</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    removeAdvisorFromClub,
    getAdvisorSubjects,
    updateAdvisorInfo,
    changeAdvisorAccountStatus,
    getAccountContactsAndClubs
} from '../../../api/eclub'
import {
    getAccountId
} from '../../../utils/store'
export default ({
    name: 'index',
    data() {
        return {
            dataList: [],
            genderList: [{
                label: 'Male',
                value: '男',
            }, {
                label: 'Female',
                value: '女',
            }],
            subjectList: [],
            advisorInfo: {
                id: '',
                account_id: getAccountId(),
                contact_discipline: '',
                contact_email: '',
                contact_prefix: '',
                contact_position: '',
                contact_givenName: '',
                contact_lastName: ''
            },
            rules: {
                contact_givenName: [
                    { required: true, message: 'Please input the name', trigger: 'blur' },
                ],
                contact_lastName: [
                    { required: true, message: 'Please input the name', trigger: 'blur' },
                ],
                contact_email: [
                    { required: true, message: 'Please input the email', trigger: 'blur' },
                    { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }
                ],
                contact_prefix: [
                    { required: true, message: 'Please select', trigger: 'blur' },
                ],
                contact_discipline: [
                    { required: true, message: 'Please select', trigger: 'blur' },
                ],
                contact_position: [
                    { required: true, message: 'Please input', trigger: 'blur' },
                ]
            },
            showAdvisorInfoDialog: false
        }
    },
    mounted() {
        this.fetchData()
        this.requestAdvisorSubjects()
    },
    methods: {

        doRemoveAdvisorFromClub(club, advisor) {
            let advisor_name = advisor.contact_info.contact_givenName + ' ' + advisor.contact_info.contact_lastName
            let club_id = club._id && club._id.$id ? club._id.$id : (typeof club._id === 'string' ? club._id : '')
            let advisor_id = advisor.contact_info._id.$id
            this.$alert("Are you sure to remove the " + club.name + " from " + advisor_name + "'s club list？", 'Remove', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                callback: action => {
                    if (action == 'confirm') {
                        removeAdvisorFromClub(club_id, advisor_id).then((res) => {
                            this.$message.success('Removed Successfully.')
                            this.fetchData()
                        })
                    }
                }
            })
        },

        requestAdvisorSubjects() {
            getAdvisorSubjects().then((res) => {
                this.subjectList = res.data.data
            })
        },

        doChangeAdviserAccountStatus(row) {
            let status = row.account_status && row.account_status == 'inactive' ? 'inactive' : 'active'
            if (status == 'active') {
                status = 'inactive'
            } else {
                status = 'active'
            }
            changeAdvisorAccountStatus(row.contact_info._id.$id, status).then((res) => {
                this.$message.success('Account status changed successful')
                this.fetchData()
            })

        },

        fetchData() {
            getAccountContactsAndClubs(getAccountId()).then((res) => {
                this.dataList = res.data.data
            })
        },
        doShowEditAdvisorDialog(row) {
            if (row) {
                
                this.advisorInfo = {
                    id: row.contact_info._id.$id,
                    account_id: row.account_id,
                    contact_discipline: row.contact_info.contact_discipline,
                    contact_email: row.contact_info.contact_email,
                    contact_prefix: row.contact_info.contact_prefix,
                    contact_position: row.contact_info.contact_position,
                    contact_givenName: row.contact_info.contact_givenName,
                    contact_lastName: row.contact_info.contact_lastName
                }
                console.log(this.advisorInfo)
            } else {
                this.advisorInfo = {
                    id: '',
                    account_id: getAccountId(),
                    contact_discipline: '',
                    contact_email: '',
                    contact_prefix: '',
                    contact_position: '',
                    contact_givenName: '',
                    contact_lastName: ''
                }
            }
            this.showAdvisorInfoDialog = true
        },
        saveAdvisorInfo() {
            this.$refs.form.validate((val) => {
                if (val) {
                    updateAdvisorInfo(this.advisorInfo).then((res) => {
                        this.fetchData()
                        if (this.advisorInfo.id == '') {
                            this.$message.success('Adviser Added Successfully')
                        } else {
                            this.$message.success('Adviser Information Updated Successfully')
                        }
                        this.showAdvisorInfoDialog = false
                    })
                }
            })
        },
        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: GravityBold;'
        },
    }
})
</script>
<style scoped lang="scss">
::v-deep  .el-table .custom-row-bg {
    // background: #FF8833;
}

::v-deep  .el-table .custom-head-cell {
    background: #FF8833;
    color: white;
    // text-align: center;
    // border: 1px solid white;
    box-sizing: border-box;
    font-family: GravityBold;
}
</style>
